// src/config/configMaps.js
import defaultLocationSearches from './configDefaultLocationSearches';

//////////////////////////////////////////////////////
// Configurations related to maps and map providers //
//////////////////////////////////////////////////////

export const mapboxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
export const googleMapsAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Choose map provider: 'mapbox', 'googleMaps'
export const mapProvider = 'mapbox';

/**
 * Locale helpers (EN/TH only)
 * We use the same rule as the app:
 * - th => Thai
 * - everything else => English
 */
const getLocaleFromLocalStorage = () => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem('locale');
};

const normalizeLocale = locale => ((locale || 'en').toLowerCase() === 'th' ? 'th' : 'en');

/**
 * Locale for maps.
 * - Mapbox: used for geocoding endpoints / UI strings (if you use Mapbox geocoder)
 * - Google: used by loader via script language param (handled in util/googleMaps.js)
 */
export const mapLocale = normalizeLocale(getLocaleFromLocalStorage());

export const search = {
  suggestCurrentLocation: true,
  currentLocationBoundsDistance: 1000,

  // Default locations already locale-aware inside configDefaultLocationSearches.js
  defaults: defaultLocationSearches || [],

  sortSearchByDistance: false,

  // Optional: if you want to limit Thailand only
  // countryLimit: ['TH'],
};

export const fuzzy = {
  enabled: true,
  offset: 500,
  defaultZoomLevel: 15,
  circleColor: '#FFFB02',
};
